import { FC } from 'react'
import 'swiper/css'
import { SwiperSlide } from 'swiper/react'

import { LoyaltySlideContent } from './ui/loyalty-slide/LoyaltySlideContent'

import cl from './LoyaltySection.module.scss'

export interface LoyaltySectionProps {
	title?: string
	list: {
		title: string
		subtitle: string
		getPercent: { value: string[] | string; notation: string[] | string }
		paymentPercent: { value: string; notation: string }
	}[]
}

export const LoyaltySection: FC<LoyaltySectionProps> = props => {
	const { list, title } = props
	return (
		<section className={cl.root}>
			{title && <h2>{title}</h2>}
			<ul className={cl.swiper}>
				{list.map(item => (
					<SwiperSlide key={item.title} className={cl.slide}>
						<LoyaltySlideContent {...item} />
					</SwiperSlide>
				))}
			</ul>
		</section>
	)
}
